import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import { colors } from '../../config/constants';
import PageHeading from '../../components/PageHeading/PageHeading';
import Dailog from '../../components/Dailog/Dailog';
import ToggleButton from '../../components/ToggleButton/ToggleButton';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import { errorMessage } from '../../config/errorsMsg';
import { errorMessageAutoCapitalize } from '../../config/helpers';
import Dropdown from '../../components/Dropdown/Dropdown';
import Copy from '../../components/Copy/Copy';
import { successMessage } from '../../config/keyword';
interface ResponseProps {
  id: string;
  code: string;
  name: string;
}

interface OrganizationProps {
  code: string;
  name: string;
}

interface Org2FaStorageProps {
  twoFactorEnabled: boolean;
  dataStorePath: string;
  fileStoreDriveId: string;
}

interface StorageProps {
  code: string;
  drivePath: string;
  id: string;
  memoryUsed: number | null;
  totalMemory: number | null;
  type: number | null;
  updatedDate: string;
}

const OrganizationSettings = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [orgSettingEditCancel, setOrgSettingEditCancel] = useState<boolean>(true);
  const [authenticationEdit, setAuthenticationEdit] = useState<boolean>(true);
  const [storageEdit, setStorageEdit] = useState<boolean>(true);
  const [authenticationResponse, setAuthenticationResponse] =
    useState<boolean>(true);

  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [formError, setFormError] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [organization, setOrganization] = useState<OrganizationProps>({
    code: '',
    name: '',
  });
  const [state, setState] = useState<OrganizationProps>({
    code: '',
    name: '',
  });
  const [organization2FaState, setOrganization2FaState] = useState<boolean>(false);
  const [org2FaStorage, setorg2FaStorage] = useState<Org2FaStorageProps>({
    twoFactorEnabled: organization2FaState,
    dataStorePath: '',
    fileStoreDriveId: '',
  });
  const [org2FaStorageBtn, setorg2FaStorageBtn] = useState<Org2FaStorageProps>({
    twoFactorEnabled: organization2FaState,
    dataStorePath: '',
    fileStoreDriveId: '',
  });
  const { fileStoreDriveId } = org2FaStorage;

  const [storageCode, setStorageCode] = useState<StorageProps>({
    code: '',
    drivePath: '',
    id: '',
    memoryUsed: null,
    totalMemory: null,
    type: null,
    updatedDate: '',
  });
  const { name, code } = organization;
  const [fileStoreCode, setFileStoreCode] = useState<ResponseProps[]>([
    { id: '', name: '', code: '' },
  ]);
  const [confirmDailog, setConfirmDialog] = useState<string>('');
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    retentionCount: '',
    needsBackup: '',
    fileStoreDriveId: '',
    backupFileStoreDriveId: '',
  });
  const [savedData, setSavedData] = useState<null | typeof formData>(null);

  useEffect(() => {
    const breadcrumb = [
      { path: '/organization', name: 'Organization' },
      { path: `/organizationSettings/${id}`, name: 'Organization Settings' },
    ];
    dispatch(update_breadcrumb(breadcrumb));
    getOrganizationById();
    getOrganization2fa();
    getAllStorage();
    getBackup();
  }, []);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit && !orgSettingEditCancel) {
      updateOrganization();
    } else if (Object.keys(formError).length === 0 && isSubmit && !storageEdit) {
      updateStorageOrganization();
    }
  }, [formError]);

  const orgHandleEditUpdate = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const fileStoreEditUpdate = () => {
    setFormError(validationStorage());
    setIsSubmit(true);
  };

  const storageHandleEdit = () => {
    setStorageEdit(!storageEdit);
  };

  const authenticationHandleEdit = () => {
    setAuthenticationEdit(!authenticationEdit);
  };

  const handle2FaToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOrganization2FaState(e.target.checked);
  };

  const handleRetentionChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleCancel = () => {
    if (savedData) setFormData(savedData);
    setEditMode(false);
  };

  const handleUpdate = () => {
    if (
      !formData.retentionCount ||
      isNaN(Number(formData.retentionCount)) ||
      Number(formData.retentionCount) <= 0
    ) {
      setFormError({ retentionCount: 'Retention count must be greater than 0' });
      return;
    }
    setFormError({});
    setSavedData(formData);
    updateBackupSettings();
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.name === 'code') {
      const format = /^\S*$/;
      format.test(event.target.value) &&
        setOrganization({
          ...organization,
          [event.target.name]: event.target.value,
        });
    } else {
      setOrganization({
        ...organization,
        [event.target.name]: event.target.value,
      });
    }
    if (event.target.value !== '') {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `Organization ${event.target.name} is required`,
      });
    }
  };

  const gotResponse = (data: ResponseProps) => {
    setOrganization(data);
    setState(data);
    dispatch(updateIsLoading(false));
  };

  const orgEditCancel = () => {
    setOrgSettingEditCancel(!orgSettingEditCancel);
    setOrganization(state);
    setFormError({});
    setIsSubmit(false);
  };

  const validation = () => {
    const error: any = {};
    if (!code) {
      error.code = errorMessage.emptyOrgCode;
    } else if ((code.length > 0 && code.length < 2) || code.length > 16) {
      error.code = errorMessage.orgCodeLength;
    }
    if (!name) {
      error.name = errorMessage.emptyOrgName;
    } else if ((name.length > 0 && name.length < 2) || name.length > 64) {
      error.name = errorMessage.orgNameLength;
    }
    return error;
  };

  const validationStorage = () => {
    const error: any = {};
    if (!fileStoreDriveId) {
      error.fileStoreDriveId = errorMessage.fileStoreDriveCode;
    }
    return error;
  };

  const getBackup = async () => {
    try {
      const response = await instance.get(`/organizations/${id}/settings/backup`);
      if (response.status === 200) {
        const item = response.data;
        const formattedData = {
          needsBackup: item.backupEnabled === true ? 'yes' : 'no',
          retentionCount: item.backupRetentionCount || 0,
          fileStoreDriveId: org2FaStorage.fileStoreDriveId,
          backupFileStoreDriveId: item.backupFileStoreId || '',
        };
        setFormData(formattedData);
        setSavedData(formattedData);
      }
    } catch (err: any) {
      const obj = {
        isOpen: true,
        message: err.response?.data?.Message || 'Failed to fetch backup settings',
        type: flashBarTheme.ERROR,
      };
      dispatch(updateFlashBar(obj));
    }
  };

  const updateBackupSettings = async () => {
    try {
      const payload = {
        backupEnabled: formData.needsBackup === 'yes',
        backupFileStoreId: formData.backupFileStoreDriveId,
        backupRetentionCount: Number(formData.retentionCount),
      };

      const response = await instance.put(
        `/organizations/${id}/settings/backup`,
        payload
      );

      if (response.status === 200) {
        const obj = {
          isOpen: true,
          message: successMessage.BACKUP_UPDATE,
          type: flashBarTheme.SUCCESS,
        };
        dispatch(updateFlashBar(obj));
        setEditMode(false);
        setSavedData(formData); // update view mode values
      }
    } catch (err: any) {
      const obj = {
        isOpen: true,
        message: err.response?.data?.Message || 'Failed to update backup settings',
        type: flashBarTheme.ERROR,
      };
      dispatch(updateFlashBar(obj));
    }
  };

  const getAllStorage = async () => {
    await instance
      .get('/filestore-drives')
      .then((response) => {
        if (response.status === 200) {
          // console.log(response.data);
          setFileStoreCode(
            response.data.map((item: ResponseProps) => {
              return { id: item.id, name: item.code };
            })
          );
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const getOrganizationById = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/organizations/${id}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const getOrganization2fa = async () => {
    await instance
      .get(`/organizations/${id}/settings`)
      .then((response) => {
        if (response.status === 200) {
          got2FaResponse(response.data);
          getStorageById(response.data.fileStoreDriveId);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const got2FaResponse = (data: Org2FaStorageProps) => {
    setOrganization2FaState(data.twoFactorEnabled);
    setAuthenticationResponse(data.twoFactorEnabled);
    setorg2FaStorage(data);
    setorg2FaStorageBtn(data);
  };

  const updateOrganization = async () => {
    await instance
      .put(`/organizations/${id}`, organization)
      .then((response) => {
        if (response.status === 200) {
          setOrgSettingEditCancel(!orgSettingEditCancel);
          getOrganizationById();
          const obj = {
            isOpen: true,
            message: successMessage.ORGANIZATIONS_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || err.response.data.errors.Code[0],
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const updateStorageOrganization = async () => {
    const obj = {
      dataStorePath: org2FaStorage.dataStorePath,
      fileStoreDriveId: org2FaStorage.fileStoreDriveId,
    };
    await instance
      .put(`/organizations/${id}/settings`, obj)
      .then((response) => {
        if (response.status === 200) {
          setStorageEdit(!storageEdit);
          getStorageById(fileStoreDriveId);
          const obj = {
            isOpen: true,
            message: successMessage.ORGANIZATION_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          getOrganization2fa();
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
    setIsDeletePopup(false);
  };

  const updateOrganizationSettings = async () => {
    await instance
      .put(`/organizations/${id}/settings/2fa/${organization2FaState}`)
      .then((response) => {
        if (response.status === 200) {
          setAuthenticationEdit(!authenticationEdit);
          const obj = {
            isOpen: true,
            message: successMessage.ORGANIZATIONSETTING_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          getOrganization2fa();
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const deleteOrganization = async () => {
    await instance
      .delete(`/organizations/${id}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.ORGANIZATION_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsDeletePopup(false);
          navigate(`/organization`);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const getStorageById = async (id: string) => {
    if (id !== '00000000-0000-0000-0000-000000000000') {
      await instance
        .get(`/filestore-drives/${id}`)
        .then((response) => {
          if (response.status === 200) {
            setStorageCode(response.data);
          }
        })
        .catch((err) => {
          const obj = {
            isOpen: true,
            message: err.response.data.Message,
            type: flashBarTheme.ERROR,
          };
          dispatch(updateFlashBar(obj));
        });
    }
  };

  const handleChangeText = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setorg2FaStorage({ ...org2FaStorage, [event.target.name]: event.target.value });
    if (event.target.value !== '' || Number(event.target.value) !== 0) {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required  `,
      });
    }
  };

  const onSubmit = () => {
    if (confirmDailog === 'update') {
      fileStoreEditUpdate();
    }
    if (confirmDailog === 'delete') {
      deleteOrganization();
    }
  };

  const fullPath = () => {
    const path = storageCode.drivePath + '\\' + org2FaStorage.dataStorePath;
    return path.length > 50 ? path.substring(0, 50) + '...' : path;
  };

  return (
    <>
      <div className="px-2">
        <PageHeading label="Organization Details" />
        <div className="bg-white rounded-sm p-5 shadow-md">
          <div className={`${colors.primaryText} flex flex-col justify-between `}>
            <div className="sm:flex text-md mb-2">
              <div className="sm:w-1/3 ">Code</div>
              {orgSettingEditCancel ? (
                <div className=" text-black flex sm:w-2/4">
                  <div>{code}</div>
                </div>
              ) : (
                <div className="sm:w-2/4">
                  <Input
                    type={'text'}
                    placeholder={'Enter code'}
                    value={code}
                    name={'code'}
                    onChange={handleChange}
                    error={formError?.code}
                  />
                </div>
              )}
            </div>
            <div className="sm:flex text-md mb-2">
              <div className="sm:w-1/3 ">Name</div>
              {orgSettingEditCancel ? (
                <div className=" text-black flex sm:w-2/4">
                  <div>{name}</div>
                </div>
              ) : (
                <div className="sm:w-2/4">
                  <Input
                    type={'text'}
                    placeholder={'Enter name'}
                    value={name}
                    name="name"
                    onChange={handleChange}
                    error={formError?.name}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="flex items-center justify-end">
            {orgSettingEditCancel ? (
              <div className="flex justify-center md:justify-end pt-5 md:pt-0">
                <Button
                  label="Edit"
                  buttonType="primary"
                  type="button"
                  onClick={() => setOrgSettingEditCancel(!orgSettingEditCancel)}
                />
              </div>
            ) : (
              <div className="mt-5 flex mx-auto md:mx-0 justify-end w-[250px]">
                <div className="mr-4">
                  <Button
                    label="Update"
                    buttonType="primary"
                    type="button"
                    onClick={() => orgHandleEditUpdate()}
                    disabled={name === state.name && code === state.code}
                  />
                </div>
                <Button
                  label="Cancel"
                  buttonType="danger"
                  type="button"
                  onClick={() => orgEditCancel()}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="px-2 mt-3">
        <PageHeading label="Settings" color={'#27374d'} />
        <div className="bg-white rounded-xl p-5 shadow-md">
          <div className={`sm:flex text-md mb-2 items-center ${colors.primaryText}`}>
            <div className="sm:w-1/3 ">Enable 2-factor Authentication</div>
            {authenticationEdit ? (
              <div className=" text-black flex sm:w-2/4">
                <div>{organization2FaState == true ? 'Yes' : 'No'}</div>
              </div>
            ) : (
              <div className="sm:w-2/4 my-1">
                <ToggleButton
                  isOn={organization2FaState}
                  handleToggle={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handle2FaToggle(e)
                  }
                />
              </div>
            )}
          </div>
          <div className="flex items-center justify-end pt-5 md:pt-0">
            {authenticationEdit ? (
              <div className="flex justify-center md:justify-end">
                <Button
                  label="Edit"
                  buttonType="primary"
                  type="button"
                  onClick={() => authenticationHandleEdit()}
                />
              </div>
            ) : (
              <div className="mt-5 flex mx-auto md:mx-0 justify-end w-[250px]">
                <div className="mr-4">
                  <Button
                    label="Update"
                    buttonType="primary"
                    type="button"
                    onClick={() => updateOrganizationSettings()}
                    disabled={organization2FaState === authenticationResponse}
                  />
                </div>
                <Button
                  label="Cancel"
                  buttonType="danger"
                  type="button"
                  onClick={() => {
                    setAuthenticationEdit(!authenticationEdit);
                    setOrganization2FaState(authenticationResponse);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="px-2 mt-3">
        <div className="bg-white rounded-xl p-5 shadow-md">
          <div className={`sm:flex text-md mb-2 items-center ${colors.primaryText}`}>
            <div className="sm:w-1/3 ">Data Store Path</div>
            <div className=" text-black flex sm:w-2/4">
              <div>{org2FaStorage.dataStorePath}</div>
            </div>
          </div>
          <div className={`sm:flex text-md mb-2 items-center ${colors.primaryText}`}>
            <div className="sm:w-1/3 ">File Store Code</div>
            {storageEdit ? (
              <div className=" text-black flex sm:w-2/4">
                <div>{storageCode.code}</div>
              </div>
            ) : (
              <div className="sm:w-2/4 my-1">
                <Dropdown
                  name="fileStoreDriveId"
                  value={org2FaStorage.fileStoreDriveId}
                  onChange={(event) => handleChangeText(event)}
                  error={formError?.fileStoreDriveId}
                  initialOption={{
                    name: 'Select Label',
                    id: '',
                  }}
                  options={fileStoreCode}
                />
              </div>
            )}
          </div>
          {storageEdit && (
            <div
              className={`sm:flex text-md mb-2 items-center ${colors.primaryText}`}
            >
              <div className="sm:w-1/3 ">Full Path</div>
              <div className=" text-black flex sm:w-2/4 space-x-4 break-all">
                <div>{fullPath()}</div>
                <Copy
                  path={storageCode.drivePath + '\\' + org2FaStorage.dataStorePath}
                  isOpen={false}
                />
              </div>
            </div>
          )}

          <div className="flex items-center justify-end pt-5 md:pt-0">
            {storageEdit ? (
              <div className="flex justify-center md:justify-end">
                <Button
                  label="Edit"
                  buttonType="primary"
                  type="button"
                  onClick={() => storageHandleEdit()}
                />
              </div>
            ) : (
              <div className="mt-5 flex mx-auto md:mx-0 justify-end w-[250px]">
                <div className="mr-4">
                  <Button
                    label="Update"
                    buttonType="primary"
                    type="button"
                    onClick={() => {
                      setIsDeletePopup(true);
                      setConfirmDialog('update');
                    }}
                    disabled={
                      org2FaStorageBtn.fileStoreDriveId ===
                      org2FaStorage.fileStoreDriveId
                    }
                  />
                </div>
                <Button
                  label="Cancel"
                  buttonType="danger"
                  type="button"
                  onClick={() => {
                    setStorageEdit(!storageEdit);
                    setFormError({});
                    setIsSubmit(false);
                    getOrganization2fa();
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="bg-white rounded-xl p-5 mt-4 shadow-md">
          {/* Backup needed */}
          {/* Do you need Backup */}
          <div className={`sm:flex text-md items-center ${colors.primaryText}`}>
            <div className="sm:w-1/3">Do you need Backup</div>
            <div className="sm:w-2/4 my-1 text-black">
              {editMode ? (
                <ToggleButton
                  isOn={formData.needsBackup === 'yes'}
                  handleToggle={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setFormData((prev) => ({
                      ...prev,
                      needsBackup: e.target.checked ? 'yes' : 'no',
                    }))
                  }
                />
              ) : (
                <span className="capitalize">{savedData?.needsBackup || '-'}</span>
              )}
            </div>
          </div>
          {/* Retention Count */}
          <div className={`sm:flex text-md items-center ${colors.primaryText}`}>
            <div className="sm:w-1/3">Retention Count</div>
            <div className="sm:w-2/4 my-1">
              {editMode ? (
                <Input
                  type="number"
                  name="retentionCount"
                  placeholder="Enter retention count..."
                  value={formData.retentionCount}
                  onChange={(event) => handleRetentionChange(event)}
                  error={formError.retentionCount}
                />
              ) : (
                <span className="text-black">
                  {savedData?.retentionCount || '0'}
                </span>
              )}
            </div>
          </div>

          {/* File Store Dropdown */}
          <div className={`sm:flex text-md mb-2 items-center ${colors.primaryText}`}>
            <div className="sm:w-1/3">Backup file Code</div>
            <div className="sm:w-2/4 my-1">
              {editMode ? (
                <Dropdown
                  name="backupFileStoreDriveId"
                  value={formData.backupFileStoreDriveId}
                  onChange={handleRetentionChange}
                  initialOption={{ name: 'Select Label', id: '' }}
                  options={fileStoreCode}
                />
              ) : (
                <span className="text-black">
                  {fileStoreCode.find(
                    (opt) => opt.id === savedData?.backupFileStoreDriveId
                  )?.name || '-'}
                </span>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex items-center justify-end pt-5 md:pt-0">
            <div className="mt-5 flex mx-auto md:mx-0 justify-end w-[250px] space-x-3">
              {editMode ? (
                <>
                  <Button
                    label="Update"
                    type="button"
                    buttonType="primary"
                    onClick={handleUpdate}
                    disabled={JSON.stringify(formData) === JSON.stringify(savedData)}
                  />
                  <Button
                    label="Cancel"
                    type="button"
                    buttonType="danger"
                    onClick={handleCancel}
                  />
                </>
              ) : (
                <Button
                  label="Edit"
                  type="button"
                  buttonType="primary"
                  onClick={handleEdit}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center pt-8">
        <Button
          label="Delete Organization"
          buttonType="danger"
          type="button"
          onClick={() => {
            setIsDeletePopup(true);
            setConfirmDialog('delete');
          }}
        />
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={'Organization'}
          onConfirm={onSubmit}
          type={confirmDailog}
        />
      </div>
    </>
  );
};

export default OrganizationSettings;
